import { MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import { ADMIN_COMPANY_SELECT_OPTIONS } from "../../constants/discoCompanies";
import { isSelectableCompanyDropdownOption } from "../../utils/adminCompany";

const getDiscoCompanyOptions = (includePitc = false) =>
  includePitc
    ? ADMIN_COMPANY_SELECT_OPTIONS
    : ADMIN_COMPANY_SELECT_OPTIONS.filter((option) => option.value !== "10");

export function getDiscoCompanyMenuItems(
  currentValue,
  includePitc = false,
  restrictToEnabled = true,
) {
  return getDiscoCompanyOptions(includePitc).map((option) => (
    <MenuItem
      key={option.value}
      value={option.value}
      disabled={
        restrictToEnabled &&
        !isSelectableCompanyDropdownOption(option.value, currentValue)
      }
    >
      {option.label}
    </MenuItem>
  ));
}

export function getDiscoCompanyNativeOptions(
  currentValue,
  includePitc = false,
  restrictToEnabled = true,
) {
  return getDiscoCompanyOptions(includePitc).map((option) => (
    <option
      key={option.value}
      value={option.value}
      disabled={
        restrictToEnabled &&
        !isSelectableCompanyDropdownOption(option.value, currentValue)
      }
    >
      {option.label}
    </option>
  ));
}

const DiscoCompanyMenuItems = ({
  includePitc = false,
  currentValue,
  restrictToEnabled = true,
}) => getDiscoCompanyMenuItems(currentValue, includePitc, restrictToEnabled);

DiscoCompanyMenuItems.propTypes = {
  includePitc: PropTypes.bool,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  restrictToEnabled: PropTypes.bool,
};

export default DiscoCompanyMenuItems;
